import * as yup from 'yup';
import { SelectDealerPageFormData } from './SelectDealerPageFormData';

export const SelectDealerPageFormSchema: yup.SchemaOf<SelectDealerPageFormData> = yup.object({
  dealerSearch: yup.string(),
  selectedDealerCode: yup.string().required(),
});
